/**
 * @Module: Application Entry Point
 * @Status: Ready
 * @Summary: Main entry point for the CHOPPY frontend
 * @Description: Initializes React application with necessary providers
 * @NextSteps: Add error boundary
 */

import React from 'react';
import { createRoot } from 'react-dom/client';
import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';
import { theme } from './theme';
import App from './App';
import { register as registerServiceWorker } from './serviceWorkerRegistration';
import { util_log_info_01 } from './utils/logging';

const container = document.getElementById('root');
if (!container) {
	throw new Error('Failed to find root element');
}

util_log_info_01('Step 1: Initializing CHOPPY frontend application');

const root = createRoot(container);
root.render(
	<React.StrictMode>
		<ChakraProvider theme={theme}>
			<ColorModeScript initialColorMode={theme.config?.initialColorMode} />
			<App />
		</ChakraProvider>
	</React.StrictMode>
);

// Register service worker for PWA install + offline support
registerServiceWorker();